import type { DeleteDepartmentTypesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteDepartmentTypesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteDepartmentTypes = createMutationHook({
  name: 'deleteDepartmentTypes',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.department.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  invalidate: (trpc) => [
    trpc.frontend.department.allTypes.queryKey(),
    trpc.frontend.department.departmentTypeById.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): DeleteDepartmentTypesMutation => ({
    deleteDepartmentTypeApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteDepartmentTypesDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['department_type'],
});
